
// sales reports routes
const PurchasesSummary = () => import("./index.vue");
const PurchaseInvoicesReport = () => import("./purchase-invoices.vue");
const PurchasedProductsReport = () => import("./purchase-products.vue");
const CombinedPurchasesReport = () => import("./combined-purchases-report.vue");
const ReturnedProductsReport = () => import("./purchase-returns.vue");
const PurchaseInvoicePreview = () => import("./invoice-preview.vue");

export default [
  {
    path: "/purchase-invoice-preview/:id",
    component: PurchaseInvoicePreview,
  },
  {
    path: "/purchases-summary",
    component: PurchasesSummary,
  },
  {
    path: "/purchase-invoices-report",
    component: PurchaseInvoicesReport,
  },
  {
    path: "/purchase-products-report",
    component: PurchasedProductsReport,
  },
  {
    path: "/purchases-return-report",
    component: ReturnedProductsReport,
  },
  {
    path: "/combined-purchases-report",
    component: CombinedPurchasesReport,
  },
];
